<template>
  <div>
    <a-card style="width: 300px; margin: 20px">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="公司名称">
          <a-select
            show-search
            v-model="form.company"
            placeholder="请选择公司名称"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
          >
            <a-select-option v-for="d in companyList" :key="d.company">{{ d.company }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="联系方式">
          <a-input placeholder="请输入联系方式" v-model="form.mobile" />
        </a-form-model-item>
        <a-form-model-item label="联络人">
          <a-input placeholder="请输入联络人" v-model="form.contactPerson" />
        </a-form-model-item>
        <a-form-model-item label="省份">
          <a-input placeholder="请输入省份" v-model="form.province" />
        </a-form-model-item>
        <a-form-model-item label="城市">
          <a-input placeholder="请输入城市" v-model="form.city" />
        </a-form-model-item>
        <a-form-model-item label="区域">
          <a-input placeholder="请输入区域" v-model="form.area" />
        </a-form-model-item>
        <a-form-model-item label="公司地址">
          <a-input placeholder="请输入公司地址" v-model="form.address" />
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import debounce from '@/components/function/debounce'
import {
  getCustomerList,
  searchCustomerList,
  getCustomerListByCompany,
  addCustomer,
  getCustomerById,
  updateCustomer
} from '@/api/customer'

export default {
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: {
        company: '',
        address: '',
        mobile: '',
        contactPerson: '',
        province: '',
        city: '',
        area: '',
        lng: null,
        lat: null,
        userId: undefined,
        salesmanId: undefined,
        serviceManId: undefined,
        followers: []
      },
      companyList: []
    }
  },
  methods: {
  }
}
</script>

<style>
</style>